import api from '../api'

const baseUrl = '/BizSchool/api/RuleAndRegulation'

const dadbanRuleProvider = {
  getRule(id) {
    return api.get(`${baseUrl}/Get/${id}`)
  },

  addRule(params) {
    return api.post(`${baseUrl}/Add`, params)
  },

  updateRule(params = {}) {
    return api.put(`${baseUrl}/Edit`, params)
  },

  getInputs() {
    return api.get(`${baseUrl}/AddInput`)
  },

  deleteRule(params) {
    return api.delete(`${baseUrl}/Delete/${params}`)
  },
}

export default dadbanRuleProvider
